module.exports = __webpack_public_path__ + "img/hafffling.d582f2b5.svg";